import React from 'react';

import RepeatIcon from './repeat0.svg';
import {
  Container,
  TestimonialsWrapper,
  Quote,
  QuoteText,
  BoldText,
  LightText,
  ReplayButton,
  RepeatImage,
  CopyText,
  LilGuy,
  EllipseWrapper,
  Ellipse,
} from './TestimonialsStyled';

export interface Testimonial {
  background: string;
  textColor: string;
  boldText: string;
  lightText: string;
}

export interface TestimonialsProps {
  testimonials: Testimonial[];
  setShowTestimonials: (show: boolean) => void;
  brand: 'teladoc' | 'talkspace';
  containerStyle?: React.CSSProperties;
  showEllipses?: boolean;
  backgroundColor?: string;
  lilGuyImgSrc?: string;
}

const SharedTestimonials: React.FC<TestimonialsProps> = ({
  testimonials,
  setShowTestimonials,
  brand,
  containerStyle,
  backgroundColor,
  showEllipses,
  lilGuyImgSrc,
}) => {
  const quotePadding = brand === 'talkspace' ? '1.5rem' : '0';

  const testId =
    brand === 'talkspace'
      ? 'talkspace-testimonial-component'
      : brand === 'teladoc'
        ? 'teladoc-testimonial-component'
        : undefined;

  return (
    <Container
      brand={brand}
      backgroundColor={backgroundColor || '#fff'}
      style={containerStyle}
      data-testid={testId}
    >
      <TestimonialsWrapper brand={brand}>
        {testimonials.map(({ background, textColor, boldText, lightText }, idx) => (
          <Quote key={idx} background={background} padding={quotePadding}>
            <QuoteText color={textColor}>
              <BoldText>{boldText}</BoldText>
              <br />
              <LightText>{lightText}</LightText>
            </QuoteText>
          </Quote>
        ))}
      </TestimonialsWrapper>

      <ReplayButton
        brand={brand}
        onClick={() => {
          setShowTestimonials(false);
        }}
      >
        <RepeatImage src={RepeatIcon} alt="Replay" />
        <CopyText>Replay</CopyText>
      </ReplayButton>

      {lilGuyImgSrc && (
        <LilGuy>
          <img src={lilGuyImgSrc} alt="character" />
        </LilGuy>
      )}

      {showEllipses && (
        <EllipseWrapper>
          <Ellipse data-testid="talkspace-ellipse" left={63.63} top={287.81} color="#FDB872" />
          <Ellipse data-testid="talkspace-ellipse" left={183.29} top={291.06} color="#FDB872" />
          <Ellipse data-testid="talkspace-ellipse" left={137.08} top={388.75} color="#FDB872" />
        </EllipseWrapper>
      )}
    </Container>
  );
};

export default SharedTestimonials;
